// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { intlShape, defineMessages } from 'react-intl';
import { getLocalizedCountry } from '../../../local-values/utils/countries';
import { freeShippingCap } from '../../../local-values/utils/benefits';
import Loading from '../../../../elements/Loading/Loading';
import {Link} from 'react-router-dom';
import CountDown from '../../../../elements/CountDown/CountDown';
import {Default} from '../../../../utils/responsive';
import environment from '../../../../environment';

import style from './TopBanner.scss';

import type { Step } from '../../duck';
import type { LocalValuesState } from '../../../local-values/duck';
import type { LocaleState } from '../../../locale/duck';
import type { Element } from 'react';

type Props = {
  +step: Step;
  +quoteType?: string;
  +total?: number;
  +localValues: LocalValuesState;
  +locale: LocaleState;
  +isLoading?: boolean;
};

const messages = defineMessages({
  missingForFreeOne: {
    id: 'newOrder.freeShippingBanner.missingForFree.one',
  },
  missingForFreeTwo: {
    id: 'newOrder.freeShippingBanner.missingForFree.two',
  },
  missingForFreeThree: {
    id: 'newOrder.freeShippingBanner.missingForFree.three',
  },
  itsFreeOne: {
    id: 'newOrder.freeShippingBanner.itsFree.one',
  },
  itsFreeTwo: {
    id: 'newOrder.freeShippingBanner.itsFree.two',
  },
  generalOne: {
    id: 'newOrder.freeShippingBanner.general.one',
  },
  generalTwo: {
    id: 'newOrder.freeShippingBanner.general.two',
  },
  moreForFreeOne: {
    id: 'newOrder.freeShippingBanner.moreForFree.one',
  },
  moreForFreeTwo: {
    id: 'newOrder.freeShippingBanner.moreForFree.two',
  },
  moreForFreeThree: {
    id: 'newOrder.freeShippingBanner.moreForFree.three',
  },
  free: {
    id: 'newOrder.freeShippingBanner.free',
  },
  error: {
    id: 'newOrder.freeShippingBanner.error',
  },
  deal: {
    id: 'newOrder.freeShippingBanner.deal',
  },
  productTest: {
    id: 'newOrder.product.hint.right',
  },
  productTestUrl: {
    id: 'newOrder.product.hint.conditions',
  },
  productCovit: {
    id: 'newOrder.product.covit19.topBaner',
  },
});

export default class TopBanner extends Component<Props> {

  buildMessage = (country: string, total: number): ?Element<'p'> => {
    const { step, locale, quoteType } = this.props;
    const amountMissing = freeShippingCap - total;
    const free = <strong>{this.context.intl.formatMessage(messages.free)}</strong>;

    const generalMessage = <p>{free} {`${this.context.intl.formatMessage(messages.generalOne)} ${country} `}
      {` ${this.context.intl.formatMessage(messages.generalTwo)} $${freeShippingCap}`}</p>;

    const congratulationMessage = <p>{`${this.context.intl.formatMessage(messages.itsFreeOne)}`} {free}
      {` ${this.context.intl.formatMessage(messages.itsFreeTwo)} ${country}`}</p>;

    if (step === 'product') {
      return generalMessage;
    }

    if (step === 'quote' && (quoteType === 'cart' || quoteType === 'offline-cart')) {
      if (total <= freeShippingCap) {
        return <p>{`${this.context.intl.formatMessage(messages.moreForFreeOne)} $${amountMissing.toFixed(2)}
        ${this.context.intl.formatMessage(messages.moreForFreeTwo)} `} {free}
          {` ${this.context.intl.formatMessage(messages.moreForFreeThree)} ${country} `}</p>;
      } else {
        return congratulationMessage;
      }
    }
    if (step === 'quote' && (quoteType === 'bag' || quoteType === 'offline-bag')) {
      if (total <= freeShippingCap) {
        // return generalMessage;
        return <p>{`${this.context.intl.formatMessage(messages.moreForFreeOne)} $${amountMissing.toFixed(2)}
        ${this.context.intl.formatMessage(messages.moreForFreeTwo)} `} {free}
          {` ${this.context.intl.formatMessage(messages.moreForFreeThree)} ${country} `}</p>;
      } else {
        return congratulationMessage;
      }
    }

    /*
    if (['PE', 'CO'].includes(locale.domainCountry)) {
      const generalMessage = <p>{free} {`${this.context.intl.formatMessage(messages.generalOne)} ${country} `}
        {` ${this.context.intl.formatMessage(messages.generalTwo)} $${freeShippingCap}`}</p>;
      const congratulationMessage = <p>{`${this.context.intl.formatMessage(messages.itsFreeOne)} `} {free}
        {` ${this.context.intl.formatMessage(messages.itsFreeTwo)} ${country}`}</p>;

      if (step === 'product') {
        return generalMessage;
      }

      if (step === 'quote' && quoteType === 'cart') {
        if (total < freeShippingCap) {
          return <p>{`${this.context.intl.formatMessage(messages.moreForFreeOne)} $${amountMissing.toFixed(2)}
        ${this.context.intl.formatMessage(messages.moreForFreeTwo)} `} {free}
            {` ${this.context.intl.formatMessage(messages.moreForFreeThree)} ${country} `}</p>;
        } else {
          return congratulationMessage;
        }
      }
      if (step === 'quote' && quoteType === 'bag') {
        if (total < freeShippingCap) {
          return generalMessage;
        } else {
          return congratulationMessage;
        }
      }

    } else if (locale.domainCountry === 'US') {
      const generalMessage = <p>{free} {`${this.context.intl.formatMessage(messages.generalOne)} ${country}`}
        {`${this.context.intl.formatMessage(messages.generalTwo)} ${freeShippingCap}`}</p>;
      const congratulationMessage = <p>{`${this.context.intl.formatMessage(messages.itsFreeOne)} `} {free}
        {` ${this.context.intl.formatMessage(messages.itsFreeTwo)} ${country}`}</p>;

      if (step === 'product') {
        return generalMessage;
      }

      if (step === 'quote' && quoteType === 'cart') {
        if (total < freeShippingCap) {
          return <p>{`${this.context.intl.formatMessage(messages.moreForFreeOne)} $${amountMissing.toFixed(2)}`}
            {` ${this.context.intl.formatMessage(messages.moreForFreeTwo)} `} {free}
            {` ${this.context.intl.formatMessage(messages.moreForFreeThree)} ${country}.`}</p>;
        } else {
          return congratulationMessage;
        }
      }
    } else {
      return <p>{this.context.intl.formatMessage(messages.error)}</p>;
    }
    */
  };

  /*buildMessageDeal = (country: string): ?Element<'p'> => {
    const free = <strong>{this.context.intl.formatMessage(messages.free)}</strong>;
    return <p>{free} {`${this.context.intl.formatMessage(messages.generalOne)} ${country} `}
      {` ${this.context.intl.formatMessage(messages.deal)}`}</p>;
  };*/
  
  render() {
    return (
      <iframe src={environment.topBannerUrl} className={style.banner} width="100%" />
    );
  }

  // README: This the former render, now it's going to be shown using webflow
  /*render() {
    const { isLoading, locale, localValues, total, step } = this.props;
    /!*const country = locale && getLocalizedCountry(locale.domainCountry || 'PE', this.context.intl.formatMessage, localValues.countriesMap);
    const parseTotal = parseFloat(total);
    if (step !== 'product' && isNaN(parseTotal)) {
      return null;
    }*!/

    // let message = this.buildMessage(country, parseTotal);
    let message;
    // TODO: This is temporary
    if (step === 'product' || step === 'quote') {
      /!*message = <p>{`${this.context.intl.formatMessage(messages.productTest)}`}
      <a href="https://help.qempo.com/article/p2n425c7eo-como-funciona-la-garant-a" target="_blank">
        {`${this.context.intl.formatMessage(messages.productTestUrl)}`}
      </a></p>;*!/
      message = (
          <p>
            ¡Ya disponible! Cotiza GRATIS tu iPhone 14, sin trámites ni impuestos, <Link to="/custom-product/iphone-14?utm_source=qempo&utm_medium=home&utm_campaign=text_header_banner_home">aquí</Link>.
          </p>
      );
    }

    return (
      <section className={style.banner}>
        {!!isLoading ? (<Loading type="circle"
                                 color="white"
                                 className={style.loading}/>) : message}
      </section>)
  }*/
}

TopBanner.propTypes = {
  step: PropTypes.string.isRequired,
  quoteType: PropTypes.string,
  total: PropTypes.number,
  localValues: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};

TopBanner.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/components/TopBanner/TopBanner.jsx